import { render, staticRenderFns } from "./VTextarea.vue?vue&type=template&id=b51a32dc"
import script from "./VTextarea.vue?vue&type=script&lang=js"
export * from "./VTextarea.vue?vue&type=script&lang=js"
import style0 from "./VTextarea.vue?vue&type=style&index=0&id=b51a32dc&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b51a32dc')) {
      api.createRecord('b51a32dc', component.options)
    } else {
      api.reload('b51a32dc', component.options)
    }
    module.hot.accept("./VTextarea.vue?vue&type=template&id=b51a32dc", function () {
      api.rerender('b51a32dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/controls/VTextarea.vue"
export default component.exports